import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default function (G6) {
  G6.registerBehavior('clickSelected', {
    getDefaultCfg: function getDefaultCfg() {
      return {
        multiple: false
      };
    },
    getEvents: function getEvents() {
      return {
        'node:click': 'onClick',
        'edge:click': 'onClick',
        'edge:mouseover': 'onEdgeMouseOver',
        'edge:mouseleave': 'onEdgeMouseLeave',
        'canvas:click': 'onCanvasClick',
        'node:mouseover': 'onNodeMouseOver'
      };
    },
    onClick: function onClick(e) {
      this._clearSelected();
      this.graph.setItemState(e.item, 'selected', true);
      var selectedItems = this.graph.get('selectedItems');
      if (!selectedItems) selectedItems = [];
      selectedItems = [e.item.get('id')];
      this.graph.set('selectedItems', selectedItems);
      this.graph.emit('afteritemselected', selectedItems);
    },
    onNodeMouseOver: function onNodeMouseOver(e) {
      if (this.graph.getCurrentMode() === 'edit') this.graph.setItemState(e.item, 'hover', true);else this.graph.setItemState(e.item, 'hover', false);
    },
    onEdgeMouseOver: function onEdgeMouseOver(e) {
      if (this.graph.getCurrentMode() === 'edit' && !e.item.hasState('selected')) this.graph.setItemState(e.item, 'hover', true);
    },
    onEdgeMouseLeave: function onEdgeMouseLeave(e) {
      if (this.graph.getCurrentMode() === 'edit' && !e.item.hasState('selected')) this.graph.setItemState(e.item, 'hover', false);
    },
    onCanvasClick: function onCanvasClick() {
      this._clearSelected();
      this.graph.emit('afteritemselected', []);
    },
    _clearSubProcessSelected: function _clearSubProcessSelected() {
      var _this = this;
      var subProcessList = this.graph.findAll('node', function (node) {
        if (node.get('model')) {
          var clazz = node.get('model').clazz;
          return clazz === 'subProcess';
        } else {
          return false;
        }
      });
      subProcessList.forEach(function (node) {
        var group = node.getContainer();
        var subGroup = group.subGroup;
        _this._clearGroupSelected(subGroup);
      });
    },
    _clearGroupSelected: function _clearGroupSelected(group) {
      var selected = group.findAll(function (subGroup) {
        var node = subGroup.get('item');
        if (node) {
          return node.hasState('selected');
        } else {
          return false;
        }
      });
      selected.forEach(function (subGroup) {
        var node = subGroup.get('item');
        if (node) {
          node.setState('selected', false);
        }
      });
    },
    _clearSelected: function _clearSelected() {
      var _this2 = this;
      var selected = this.graph.findAllByState('node', 'selected');
      selected.forEach(function (node) {
        _this2.graph.setItemState(node, 'selected', false);
      });
      selected = this.graph.findAllByState('edge', 'selected');
      selected.forEach(function (edge) {
        _this2.graph.setItemState(edge, 'selected', false);
      });
      this._clearSubProcessSelected();
      this.graph.set('selectedItems', []);
    }
  });
}